import React from 'react';
import Decimal from 'decimal.js';

import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { LINE_ITEM_PICKUP_FEE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

/**
 * A component that renders the pickup fee as a line item.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const LineItemPickupFeeMaybe = props => {
  const { lineItems, intl } = props;

  const pickupFeeLineItems = lineItems.filter(
    item => item.code === LINE_ITEM_PICKUP_FEE && !item.reversal
  );
  const pickupFeeLineItem = pickupFeeLineItems[0];
  const pickupFeeTotal =
    pickupFeeLineItems.length > 0
      ? new Money(
          pickupFeeLineItems.reduce((amount, item) => {
            return amount.plus(item.lineTotal.amount);
          }, new Decimal(0)),
          pickupFeeLineItem.lineTotal.currency
        )
      : null;

  return pickupFeeLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.pickupFee" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, pickupFeeTotal)}</span>
    </div>
  ) : null;
};

export default LineItemPickupFeeMaybe;
